import { Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const SubmitButton = ({ handleSubmit, isLoading, showButton = true }) => {
  const { t } = useTranslation();
  return (
    <div style={{ textAlign: "center", padding: "4px" }}>
      {showButton && (
        <Button
          variant="contained"
          color="success"
          style={{ marginLeft: "10px", backgroundColor: "#157CB3" }}
          disabled={isLoading}
          onClick={handleSubmit}
        >
          {t("BUTTON_EMP_SUBMITFORM")}
        </Button>
      )}
    </div>
  );
};

export default SubmitButton;
